function PartnerOf() {
    return (
       <div className="partner-comp">
          <h4>PARTNER OF</h4>
          <div className="partner-content">
             <div>
                <a href="https://www.facebook.com/business/partner-directory/search?solution_type=campaign_management&id=144864402752633&section=overview" target="_blank">
                   <img src="https://animoto.com/static/FacebookPartnerIcon-4f675b081bec613dbac01a85deceacb3.svg" alt="fb" />
                </a>
             </div>
             <div>
                <a href="https://support.google.com/youtube/answer/6145904" target="_blank">
                   <img src="https://animoto.com/static/YoutubePartnerIcon-c1d64a90323f18e6780043bcfcd98978.svg" alt="yt" />
                </a>
             </div>
             <div>
                <a href="https://business.linkedin.com/marketing-solutions/marketing-partners/find-a-partner/animoto" target="_blank">
                   <img src="https://animoto.com/static/LinkedinPartnerIcon-24d62148b51dffedabf037a759749c64.svg" alt="linkedin" />
                </a>
             </div>
             <div>
                <a href="https://business.twitter.com/en/advertising/partners/find-a-partner/animoto.html" target="_blank">
                   <img src="https://animoto.com/static/TwitterPartnerIcon-ec004db8d46ae33366ce5ce169fa44ee.svg" alt="twitter" />
                </a>
             </div>
             <div>
                <a href="https://community.hubspot.com/t5/Releases-and-Updates/HubSpot-Connect-Animoto-Integration/ba-p/417707" target="_blank">
                   <img src="https://animoto.com/static/HubspotPartnerIcon-c7fb5a3e97b9754634f47b1680b8deb9.svg" alt="hubSpot" />
                </a>
             </div>
          </div>
       </div>
    );
 }
 
 export default PartnerOf;